import faqInlineImg from '../assets/images/faq-data-img.png'
import faqInlineImg1 from '../assets/images/clan-verified.svg'
import faqInlineImg2 from '../assets/images/faq-data-img-plus.png'

export const InfluencerHeaderMenu = {
  mainMenu: [
    {
      id: 1,
      title: "Dashboard",
      url: "/influencer/dashboard",
    },
    {
      id: 2,
      title: "My Campaigns",
      url: "/influencer/mycampaigns",
    },
    {
      id: 3,
      title: "Profile View",
      url: "/influencer/profile-view",
    },
    {
      id: 4,
      title: "Zap",
      url: "/influencer/zap",
    },
    // Storefront and Link in Bio are now accessed from within the Zap hub, so they are
    // removed from the header nav.
    // {
    //   id: 7,
    //   title: "Storefront",
    //   url: "/influencer/storefront",
    // },
    // {
    //   id: 9,
    //   title: "Link in Bio",
    //   url: "/influencer/link-in-bio",
    // },
    // {
    //   id: 4,
    //   title: "Inbox Chat",
    //   url: "influencer/campaign-msg",
    // },
    // {
    //   id: 4,
    //   title: "Clan Shop",
    //   url: "/influencer/clanshop",
    // },
    // Keep setting in the last
    // {
    //   id: 5,
    //   title: "Settings",
    //   url: "/influencer/settings/security",
    // },
    {
      id: 5,
      title: "Inbox",
      url: "/influencer/campaign-msg",
    },
    {
      id: 6,
      title: "Admin Dashboard",
      url: "/brand/admin-dashboard/influencer-signups",
    },
    {
      id: 10,
      title: "Affiliate Deals",
      url: "/influencer/brand-deals",
    },
  ],
};


export const BrandHeaderMenu = {
  mainMenu: [
    // The new Home (brand app parity + the old dashboard's Overview); /brand/dashboard redirects here.
    {
      id: 1,
      title: "Dashboard",
      url: "/brand/home",
    },
    // The new Discover (brand app parity); the old one moved to /brand/old-discover.
    {
      id: 2,
      title: "Discover",
      url: "/brand/discover",
    },
    // The new campaign flow (brd_*). The old one stays at /brand/plans,
    // linked from the new Campaigns page as "Old campaigns".
    {
      id: 3,
      title: "Campaigns",
      url: "/brand/campaigns",
    },

    // The new flow's Creator Lists (the brand app's); the old page stays at /brand/list.
    {
      id: 4,
      title: "List",
      url: "/brand/profile/lists",
    },

    // {
    //   id: 5,
    //   title: "Inbox Chat",
    //   url: "brand/campaign-msg",
    // },

    // {
    //   id: 5,
    //   title: "Agreements",
    //   url: "/brand/agreements",
    // },
    // If you change id of Admin Dashboard please modify the changes in header.tsx
    {
      id: 6,
      title: "Admin Dashboard",
      url: "/brand/admin-dashboard/influencer-signups",
    },
    // The new flow's Inbox. The old one stays at /brand/campaign-msg.
    {
      id: 7,
      title: "Inbox",
      url: "/brand/inbox",
    },
    {
      id: 8,
      title: "Brand Pulse",
      url: "/brand/info/details",
    },

    // {
    //   id: 7,
    //   title: "Configurator",
    //   url: "/brand/configurator",
    // },
    // {
    //   id: 8,
    //   title: "Brand Insights",
    //   url: "/brand/info/details",
    // },
    // Keep setting in last
    // {
    //   id: 7,
    //   title: "Settings",
    //   url: "/brand/settings/security",
    // },
    // {
    //   id: 8,
    //   title: "Clan Shop",
    //   url: "/brand/clanshop",
    // },
  ],
};

// export const ProfileSettingMenu = {
//   menu: [
//     {
//       id: 1,
//       title: "My Account",
//       url: "/brand/dashboard",
//     },
//     {
//       id: 2,
//       title: "User Info",
//       url: "/brand/discover",
//     },
//     {
//       id: 3,
//       title: "Security",
//       url: "/brand/plans",
//     },
//     {
//       id: 7,
//       title: "Social Connect",
//       url: "/brand/settings/security",
//     },
//     {
//       id: 8,
//       title: "Notifications",
//       url: "/brand/list",
//     },
//     {
//       id: 4,
//       title: "Subscription",
//       url: "/subscription",
//     },
//     {
//       id: 5,
//       title: "Shipping Address",
//       url: "/brand/admin-dashboard/signup",
//     },{
//       id: 6,
//       title: "Payment Methods",
//       url: "/brand/configurator",
//     },{
//       id: 7,
//       title: "Company / Trade Details",
//       url: "/brand/configurator",
//     },{
//       id: 8,
//       title: "Invoice Settings",
//       url: "/brand/configurator",
//     },


//   ],
// };


// export const headerMenu = {
//   mainMenu: [
//     {
//       id: 1,
//       title: "Influencers",
//       url: "/influencers",
//     },
//     {
//       id: 2,
//       title: "Talent Partners",
//       url: "/talent-partners",
//     },
//     {
//       id: 3,
//       title: "Brands/Agencies",
//       url: "/brands-agencies",
//     },
//     {
//       id: 4,
//       title: "About Us",
//       url: "/about",
//     },

//     // {
//     //   id: 6,
//     //   title: "Case Studies",
//     //   url: "/case-studies",
//     // },
//     {
//       id: 5,
//       title: "Clan World",
//       url: "/clanworld",
//     },
//   ],
// };


export const faqData = [
  {
    brandsData: [
      {
        id: 1,
        faqTitle: "How to search for an Influencer?",
        img: faqInlineImg,
        faqSubtitleDescriptionList: [
          {
            id: 1,
            listDesc: "Step 1: Go to 'Search Influencer' in the left navigation panel."
          },
          {
            id: 2,
            listDesc: "Step 2: Either give a name, username for an influencer to search or click on filters to get a set of influencer results."
          },
          {
            id: 3,
            listDesc: "Step 3: Click on 'Show Results'."
          }
        ]
      },
      {
        id: 2,
        faqTitle: "How to connect with an Influencer?",
        faqDescription: "Every Influencer profile has 'Send Message' option. One can directly initiate conversation with the influencer by sending them a message."
      },
      {
        id: 3,
        faqTitle: "Can you help me in connecting with an Influencer who is not on Clanconnect?",
        faqDescription: "Our Business team get involved and connects you to the influencers who are not registered with us."
      },
      {
        id: 4,
        faqTitle: "What is a verified Influencer?",
        faqDescription: "A verified Influencer, on ClanConnect platform, is the one whose all details (includes their social channel, contact details etc.) are verified and genuine. "
      },
      {
        id: 5,
        faqTitle: "How to identify if the influencer is Clan registered?",
        content: <><p>The Clan registered influencer will have this symbol<img src={faqInlineImg1} alt="" width="16" height="16" style={{ margin: "0 5px" }} />with their profile photo</p></>,



      },
      {
        id: 6,
        faqTitle: "I see an influencer profile but is not Clan registered. Can I still reach out to him? If yes, how?",
        faqDescription: `Yes, you can still reach out to the influencers who are not registered with us. Our Business team helps in creating the contact between you and that influencer.`
      },
      {
        id: 7,
        faqTitle: "Which social platforms I can search influencers for?",
        faqDescription: `You can search the Influencers from Instagram and YouTube. Twitter will be coming next. `
      },
      {
        id: 8,
        faqTitle: "How do I create a list of selected influencers?",
        content: <><p>There are multiple ways to create a list<br />
          Method 1: Creating a list from filter search results. </p>
          <ul>
            <li>Step 1: The profile cards that appear after clicking 'Show Results' from filters have this symbol <img src={faqInlineImg2} alt="" width="16" height="16" /> Click this symbol. A dialog box will appear.</li>
            <li>Step 2: Give a list name to create a new list and add the selected influencer to that list.</li>
            <li>Step 3: Click 'Save'.</li>
            <li>You can view this list on My Lists page. </li>
          </ul><p>Method 2: Create a list from My Lists page.</p>
          <ul>
            <li>Step 1: Go to 'My Lists' page from left navigation panel.</li>
            <li>Step 2: Click on 'Create a new list' and give a name to that list. Select the platform for which you want to create that list. Click 'Save'.</li>
            <li>Step 3: Click on 'Add Influencers' to go to search page and apply filters or just select the influencers to add.</li>
            <li>
              Step 4: Click on 'Save at the right end corner to save the influencers in that list.
            </li>
          </ul></>
      },
      {
        id: 9,
        faqTitle: "Once I have posted the campaign brief, how do I see which influencers have applied to my campaign?",
        content: <><ul><li>Step 1: Go to 'Campaigns' from left navigation panel.</li>
          <li>Step 2: Click on the campaign for which you want to see the influencer proposals.</li>
          <li> Step 3: Go to 'Proposals' section of the campaign. All the proposals sent by influencers are visible here.</li>
        </ul></>
      },

      {
        id: 10,
        faqTitle: "How can I negotiate on the price quoted by the influencer for my paid campaign?",
        content: <><ul><li>Step 1: Click on the card under Proposals for which you want to negotiate.</li>
          <li>Step 2: Click on the 'Make a Counteroffer' option after opening that proposal.</li>
          <li> Step 3: A dialog box will appear where you can give the negotiated price and comments.</li>
        </ul><p>Please note that you can negotiate only if the influencer has agreed to negtiate while submitting the proposal. If not, the only available options will be Accept and Reject the proposal.</p></>
      },
      {
        id: 11,
        faqTitle: "Where can I check the creatives sent by influencers for approval?",
        content: <><ul><li>Step 1: Go to 'Campaigns' from left navigation panel.</li>
          <li>Step 2: Click on the campaign for which you want to see the influencer creatives.</li>
          <li> Step 3: Go to 'Creatives' section of the campaign.
            All the creatives sent by influencers are visible here.</li>
        </ul></>
      },
      {
        id: 12,
        faqTitle: "Can I give feedback on the creatives shared by influencers?",
        faqDescription: `Yes, you can share the feedback on the creatives shared by influencers. 

        Click on any creative and a section on the right side will open, where you can give your inputs on the creative.`
      },
      {
        id: 13,
        faqTitle: "Once the creative is approved, how can I check the schedule and details of the creative to be posted on influencer's social channel?",
        faqDescription: "To check the schedule and other deatils of the creative, click on 'Creatives' section on the campaign page. Under 'Approved' there is a section 'Scheduled'. All the creatives that are scheduled by the influencers will be visible here. Upon clicking any creative, 'Schedule' on the right panel shows all the details and time of the creative to go live."
      }, {
        id: 14,
        faqTitle: "How can I know if the creative is gone live?",
        faqDescription: `Go to 'Creatives' section of the campaign page. All creaties that are live will be listed under 'Live' section of 'Approved' tab.`
      }, {
        id: 15,
        faqTitle: "How can I check the performance of my campaign?",
        faqDescription: `Go to 'Analytics' section of the campaign page. The majority of the campaign performance data will be shown here. Detailed analytics can be viewed on going to the 'Detailed analytics' page.`
      },
      {
        id: 16,
        faqTitle: "Can I also check the performance even for one creative of the campaign?",
        faqDescription: `The 'Detailed analytics' page from the 'Analytics' section of campaign page will show all the detailed analytics related to even one single post of any influencer.`
      }, {
        id: 17,
        faqTitle: "I don't want to run influencer campaigns on my own. Does Clanconnect also help me with end to end campaign planning and execution?",
        faqDescription: `Yes, Clanconnect gives you an option to either plan and execute your influencer campaign using our sophisticated platform or let us take care of your end to end campaign requirements.`
      }
    ],
    influencerData: [
      {
        id: 1,
        faqTitle: "Does signing up with Clanconnect means I can't work with other agencies?",
        faqDescription: "Influencers are free to work with or sign up with other agencies even when they're onboarded on Clanconnect."
      }, {
        id: 2,
        faqTitle: "How do I apply to campaigns?",
        faqDescription: `Upon signing up, you can apply to the campaigns visible on your homepage (Browse Campaigns). Clicking on any campaign title takes you to the campaign page where you can view all the details for that campaign. You can either apply from the homepage or from the campaign details page.

        However, to apply, you first need to connect (if not connected already) your Instagram channel if you are an Instagram Influencer; or YouTube channel if you are a YouTube Influencer.`
      }, {
        id: 3,
        faqTitle: "Why do I need to connect my social channel to apply to the campaigns?",
        faqDescription: "The Brand would want to see your profile data insights to check if you are relevant to that campaign and shortlist you if you are a good fit. Only upon connecting your social channel, ClanConnect can access the data from your social profile and build a profile which can be viewed by Brands."
      }, {
        id: 4,
        faqTitle: "How secure is my data if I have connected my social channel?",
        faqDescription: "Your data is absolutely secure. The data is directly fetched from Instagram and YouTube and in no way the data can be misused. We recommend to connect your social media account sothat brands can view your profile analytics in order to shortlist you for the campaign."
      }, {
        id: 5,
        faqTitle: "Where can I see the campaigns to which I have applied?",
        faqDescription: "Go to 'My Campaigns from left navigation panel. All the campaigns that you have applied to or are working with, will be listed on this page."
      }, {
        id: 6,
        faqTitle: "Once the cost is approved, what should I do next?",
        faqDescription: "Once the cost is approved, you can send the creative for brand's feedback/ approval after receiving advance payments if any."
      }, {
        id: 7,
        faqTitle: "How do I submit the creatives for approval by the brand?",
        faqDescription: "Go to 'My Campaigns' from left navigation panel. Click on the campaign for which you want to send the creative. Go to 'Creatives' section of the campaign page. 'Upload' your creative to send to brands for their feedback/ approval."
      }, {
        id: 8,
        faqTitle: "Once approved, how can I schedule the creative on my channel?",
        faqDescription: "The 'Creatives' section on campaign page will show all the creatives you have sent to the brand, including the ones that are approved. Upon clicking any approved creative, you can schedule the creative in the 'Schedule' section of the right panel. "
      }, {
        id: 9,
        faqTitle: "Do I need approval by the brand before posting the creative on my social channels?",
        faqDescription: "Once the creative is scheduled, it goes to brand for their approval for posting time, caption etc. Once approved by the brand, the creative automatically gets scheduled to go live with the details given."
      },
      {
        id: 10,
        faqTitle: "Can I cancel my scheduled post? If yes, how?",
        faqDescription: "Once scheduled, the post can only be cancelled till 10 minutes prior to going live."
      },
      {
        id: 11,
        faqTitle: "When can I share an invoice?",
        faqDescription: "In case, you've asked for the advance payment you can share the invoice once your proposal is accepted. If you haven't asked for any advance payment then you can share the invoice after the creative goes live."
      },
      {
        id: 12,
        faqTitle: "How do I create an invoice?",
        faqDescription: "Go to 'Invoice' section of the campaign's page for which you want to create an invoice."
      },
      {
        id: 13,
        faqTitle: "Can I backout from a campaign after accepting it?",
        faqDescription: "When we send a campaign your way, we leave it up to your decretion to accept or reject it. But once you've accepted a campaign you will be liable to execute it fully."
      },
      {
        id: 14,
        faqTitle: "I've not been getting campaigns. What do I do?",
        faqDescription: "Please get in touch with us at influencer.support@clanconnect.ai and enlist yourself in our priority list so we don't miss out on sending you a relevant campaign."
      },
      {
        id: 15,
        faqTitle: "I am not able to apply to any campaign. What do I do?",
        faqDescription: "To apply on a campaign, you need to have a monthly or yearly subscription. Also, you need to connect the Instagram or YouTube as per the campaign requirements."
      },
      {
        id: 16,
        faqTitle: "I am not able to connect my Instagram account. How do I do it?",
        content: <><p>Please follow the steps to connect your Instagram account:</p><ul><li>You need to have a valid Facebook account</li>
          <li>The Facebook account must have a business page. You can create one under the 'Pages' section of Facebook.</li>
          <li> You need to have a business/professional Instagram account. If not, kindly update it to Business account under 'Settings {'>'} Account {'>'} Switch account type'.</li>
          <li>Connect your Facebook business page with Instagram account. To connect, go to Instagram 'Settings {'>'} Meta {'>'} Accounts Centre {'>'} Accounts.'</li>
          <li>Login to ClanConnect. Go to Settings {'>'} Social Connect. </li>
          <li>Click on Connect Facebook.</li>
          <li>Facebook screen will appear. Click on Conitnue as {'<your facebook name>'} or Edit Settings.</li>
        </ul></>,

      }
    ],

    instagramData: [



      {
        id: 4,
        faqTitle: "What is the campaign payment process?",
        faqDescription: "Once the Brand starts accepting the proposals from the Influencers, the payment shall be made to ClanConnect. This prepaid model ensures the security of the campaign. For different type of campaigns, please read the process below:",
        faqSubDescription: [
          {
            id: 1,
            faqSubtitle: "Paid Campaign",
            faqSubtitleDescription: 'The Brand can directly pay to influencers from the platform, once they have accepted the proposals as per the terms mentioned by the Influencers.'
          }, {
            id: 2,
            faqSubtitle: "Paid + Barter Campaign",
            faqSubtitleDescription: 'The Brand can directly pay to influencers from the platform, once they have accepted the proposals as per the terms mentioned by the Influencers.'
          },
          {
            id: 3,
            faqSubtitle: "Barter Campaign",
            faqSubtitleDescription: "The Brand needs to pay Rs. 200 per accepted Influencer proposal to ClanConnect. This payment can be made directly from the platform.",
          },
          {
            id: 4,
            faqSubtitle: 'CPV Campaign',
            faqSubtitleDescription: `Once the proposals are accepted by the Brand, the amount gets calculated as per the CPV model and the brand shall pay the complete amount directly to the influencers.`
          },
        ]
      },
      {
        id: 1,
        faqTitle: "How does a CPV campaign works?",
        faqDescription: "A CPV campaign works on Pay per View model. Once the proposal is accepted by the Brand, the influencer needs to get at least 50% (minimum half) of their follower number as views for the particular content to get qualified for the payout. The maximum payout shall be 200% (double) of their follower number as views, even if the influencer has received much higher views. The default number of days for the views to be counted is 14 days. "
      },
      {
        id: 2,
        faqTitle: "What are the advantages of CPV campaign?",
        faqSubDescription: [
          {
            id: 1,
            faqSubtitle: "Higher Cost efficiency",
            faqSubtitleDescription: 'The CPV model comes forward as a market disruptor where the influencer will get paid as per the view count; ie after analyzing direct benefits to the brand.'
          }, {
            id: 2,
            faqSubtitle: " Hyperlocal Reach",
            faqSubtitleDescription: 'Targeted local campaign with regional influencers'
          },
          {
            id: 3,
            faqSubtitle: "Lower CPV rates ",
            faqSubtitleDescription: "The influencers will clearly be communicated that payouts shall happen only on meeting min number of views as baseline, WITHOUT any paid promotion.",
          },
          {
            id: 4,
            faqSubtitle: 'Higher CPR efficiency',
            faqSubtitleDescription: "The cost per reach efficiency will simultaneously increase as the views increase, making the Reach cost efficient."
          }
        ]
      },



    ],
    youtubeData: [
      {
        id: 1,
        faqTitle: "What does CPM stand for and how do you calculate it?",
        faqDescription: "CPM stands for Cost Per Mille or Cost Per Thousand. CPM can be defined as the money an advertiser spends for one thousand views. Clan uses the CPM metric to calculate an approximate amount of money paid to an analysed YouTube influencer for the content they generate."
      },
      {
        id: 2,
        faqTitle: "How to generate a report on any YouTube channel?",
        faqDescription: `For a brand or an agency, the YouTube report of a certain channel/creator/influencer can be accessed by entering the channel name in the search bar and clicking on the desired account in the drop-down menu.
        
        An influencer/content creator can also see their channel’s analytics/report in their login homepage under the reports section. 
        `
      },
      {
        id: 3,
        faqTitle: "How frequently is the data updated for these YouTube reports?",
        faqDescription: `All data points barring the audience demography is updated daily. Audience demography is updated once a month.`
      },
      {
        id: 4,
        faqTitle: "What is a Channel Quality Score (CQS), and how is the CQS calculated?",
        faqDescription: ` Channel Quality score or the CQS is the effectiveness metric of any YouTube channel or an influencer. This can be used by brands/agencies to effectively plan the budgets for influencer marketing campaigns on YouTube.

        It is a metric that is learnt over time on a ML (machine learning) model for an influencer/YouTube channel. It is calculated on a range of 1-100, 100 being the highest benchmark. The following inputs determine the CQS: `,
        faqInnerDescription: {
          faqInnerDescriptionList: [
            {
              id: 1,
              listDesc: "The audience: It comprises the creator’s location, the alignment of the audience, age and gender distribution."
            },
            {
              id: 2,
              listDesc: "Credibility: Evaluates the audience’s legitimacy, the correlation between sudden spikes in views, drops in views and subscriber growth."
            },
            {
              id: 3,
              listDesc: "Engagement: component benchmarks the number of comments and reactions, views to comments ratio, upvotes to views ratio, and comments to views ratio with the similar influencers."
            },
            {
              id: 4,
              listDesc: "Creator’s influence: It is measured using the number of subscribers, stability of views, views to subscriber’s ratio, frequency of video, upvotes to downvotes ratio."
            },

          ]
        }
      },
      {
        id: 5,
        faqTitle: "How is Audience Language identified?",
        faqDescription: `It is arrived at by the language of the user content and text in their channel description.`
      }, {
        id: 6,
        faqTitle: "How is Audience Demography identified?",
        faqInnerDescription: {
          faqInnerDescriptionList: [
            {
              id: 1,
              listDesc: "For Geographical Location: This is identified using publicly available information on location from the profiles of the active audience of the influencer."
            },
            {
              id: 2,
              listDesc: "For Audience’s Age & Gender: We run through our image recognition technology over the influencer’s active audience to identify their age and the gender."
            }
          ]
        }
      },
      {
        id: 7,
        faqTitle: "What do you mean by the Similar Channels section?",
        faqDescription: `It is a recommendation given by the platform which understands the YouTube influencers/creators who in the past have made content similar to a given business/genre/category. For e.g. Recommending a tech influencer who has made engaging mobile unboxing videos to to a mobile manufacturing brand.

        It is a very effective way of planning a campaign and budgets, where a brand/agency can effectively plan an optimized campaign to deliver a certain KPI by reaching out to a content creator/creators who are more efficient but less expensive.
        
        Clan provides a list of similar channels by finding mutual qualities between influencers and their audiences considering the following attributes:`,
        faqInnerDescription: {
          faqInnerDescriptionList: [
            {
              id: 1,
              listDesc: "Audience Demographics: Factors like audience’s age, gender distribution and accounts having the same top-1 audience country. "
            },
            {
              id: 2,
              listDesc: "Influencer category and keywords that describe their content the best."
            }
          ]
        }
      },
      {
        id: 8,
        faqTitle: "What is meant by the term Video Frequency?",
        faqDescription: `The average number of uploads per week in a given time frame is called Video Frequency. It can be high or low depending on the upload frequency.

        This number is then compared by the number of views of similar accounts to give you a benchmark that assists in comprehending how an influencer has performed. `,
      },
      {
        id: 9,
        faqTitle: "What is meant by the term Audience Attitude?",
        faqDescription: `The ratio of Likes to dislikes, which helps in understanding whether an influencer’s video is being liked or disliked by their audience.

        The benchmark of the same is arrived at by comparing this metric with similar accounts to give you a benchmark that assists in understanding how the influencer’s audience reacts to their content. It can be a useful metric for planning if you are likely to consider/evaluate how a content will resonate with audiences after it has been posted.`
      },
      {
        id: 10,
        faqTitle: "What is 'Reaction Rate'?",
        faqDescription: `Likes and dislikes per 1000 views in a given time frame is referred to as the Reaction Rate.

        We compare this number with similar accounts by the number of views and give you a benchmark that helps to understand how engaged an influencer’s audience is. It can be a useful metric for planning if you are likely to consider/evaluate how the audience will engage when a content is posted by an influencer.`
      },
      {
        id: 11,
        faqTitle: "What is meant by Average engagement per video? How is it calculated?",
        faqDescription: `The median number of likes, dislikes, and comments per video in a timeframe indicates the Average engagement per video of that channel.

      Clan compares this number with the past numbers, for a better understanding of how an influencer is has performed in a given time frame.`
      },
      {
        id: 12,
        faqTitle: "Why is median calculated and not average of engagement metrics?",
        faqDescription: "The median unlike the average, does not consider a very large or too small engagement numbers but it looks at the middle of any data set divided in two halves which may give a better idea about engagement."
      },
      {
        id: 13,
        faqTitle: "What do you mean by Average views per video?",
        faqDescription: `It is the calculation of the median number of views on all videos in a given timeframe. However, we do not consider videos posted in the last week as the view numbers pertaining to a video may take a week to stabilize and doesn’t show any unusual spike or variation from the normal.

        The minimum view is the minimum number of views for a video in a given timeframe, and maximum view is the maximum number in a given timeframe. `
      },
      {
        id: 14,
        faqTitle: "What is meant by the term 'Subscribers Growth'?",
        faqDescription: `The number of people that have subscribed to a YouTube influencer’s account/channel in a given time frame reflects the Subscribers Growth. We compare this number with a previous period to help you understand how an influencer performs over time.

        The number of subscribers can also come out to be negative on certain days. Regular verification is done by YouTube to ensure the authenticity of the accounts and actions on all YouTube channels to make sure that metrics are free of spam, abuse, and closed accounts.`
      },
      {
        id: 15,
        faqTitle: "How are video views calculated?",
        faqDescription: `New views reflect how often an influencer’s videos has been viewed in a specific time frame and can be a significant measure of a video's overall popularity.

        For your better understanding of how an influencer performs over time, we compare this number with that of an earlier period.
        
        Owing to the fact that YouTube can discard low-quality playbacks, the number of views could be negative on a specific day.`
      },
      {
        id: 16,
        faqTitle: "What do you mean by Estimated Integration Price?",
        faqDescription: "The approximate price of one video with a brand mention posted by an influencer’s YouTube account is the Estimated Integration Price. Clan shows an estimated price that is calculated on the basis market research and intelligence. Please note that the actual price might be different."
      },
      {
        id: 17,
        faqTitle: "What is the Brand Mentions section and how to read it?",
        faqDescription: "Brand mention section can be found at the bottom of Each YouTube Report, only if an influencer has at least one mention over the past 90 days. The following could be included:",
        faqInnerDescription: {
          faqInnerDescriptionList: [
            {
              id: 1,
              listDesc: "Name of a brand and link to the brand website."
            },
            {
              id: 2,
              listDesc: "Total views. {If an influencer mentioned a brand in several videos, it is the sum of all views in those mentioned videos)"
            },
            {
              id: 3,
              listDesc: "CPM and its benchmark/performance. The benchmark is given basis the CPM of other videos of the influencer."
            },

          ],
          id: 0,
          desc: `Analysing brand mentions is an integral part of the growth strategy. Marketers can ascertain the collaborations which worked and vice-versa, basically understanding which videos did well in terms of the CPM. `
        }
      },
      {
        id: 18,
        faqTitle: "Why am I unable to check the audience demographic for a specific YouTube channel?",
        faqDescription: "It is possible that sometimes you might not see the audience demography. It is because of unavailability of sufficient reliable data to conduct the analysis.",
      },
      {
        id: 19,
        faqTitle: "What does the term EMV mean? How is it calculated?",
        faqDescription: "Earned Media Value or the EMV means/is reflective of the amount a brand would have spent to garner the same reach via paid social ads targeted at an audience with similar demographics. It is done by assigning a monetary value to every like, comment, and interaction made with a post or account on social media and adding it together to calculate the total value of their “earned” interactions. It's important to note that not all social media interactions are equal, but they all provide some value.",
        faqInnerDescription: {
          faqInnerDescriptionList: [
            {
              id: 1,
              listDesc: "Reach: Approximate number of impressions that every post deliver, the activity which could be termed as fraud or inauthentic is removed from this approximation."
            },
            {
              id: 2,
              listDesc: "Engagement: Likes, views and comments."
            },
            {
              id: 3,
              listDesc: "Follower count"
            },
            {
              id: 4,
              listDesc: "Account quality and authenticity"
            },
            {
              id: 5,
              listDesc: "Demographics: Audience’s age, sexual orientation, and Geographic location"
            },

          ],
          id: 0,
          desc: `The following metrics are calculated to arrive at the EMV:`
        }

      }
    ]
  }

];

export const InfluencerThankYouMessage = {
  sectionTitle: "Join our WhatsApp Community",
  content: <>Want to stay in the loop with our latest campaigns and offers? Join our <strong> WhatsApp community!</strong> <br />Simply pick the group that matches your follower base for tailored campaign alerts.</>,
  footerMessage: <>You can join the community later as well. These links will be available
    under your <strong>Social Connect</strong> of Profile Settings.</>,

  thankYouMsg: [
    {
      id: 1,
      title: "Nano (1K - 10K)",
      url: "https://chat.whatsapp.com/Duirgq03Bo94D5mKB3Pkl5",
    },
    {
      id: 2,
      title: "Micro (10K - 50K)",
      url: "https://chat.whatsapp.com/Deo04GzI6RF5TJwCDDNkAb",
    },
    {
      id: 3,
      title: "Micro Plus (50K - 100K)",
      url: "https://chat.whatsapp.com/JABYW23EiruJNxtwzc9Slt",
    },

    {
      id: 4,
      title: "Macro (100K - 500K)",
      url: "https://chat.whatsapp.com/GZC5eEjseo6JrZvkN3VfqI",
    },
    {
      id: 5,
      title: "Macro Plus (500K - 1M)",
      url: "https://chat.whatsapp.com/EPh3ftxcGf2AKXdI255rmK",
    },
    {
      id: 6,
      title: "Mega (1M+)",
      url: "https://chat.whatsapp.com/G4vHsZJkLwxKKUuK051C2Y",
    }
  ],
};

export const Trivia = {
  Trivia_array: [
    {
      id: 1,
      content: `The first social networking site was Six Degrees, created in 1997. Users could create a profile and connect with other users.`,
    },
    {
      id: 2,
      content: `Facebook, launched in 2004, was originally called "The Facebook" and was limited to Harvard students. It later expanded to other universities and eventually the general public.`,
    },
    {
      id: 3,
      content: `Twitter was originally called "twttr" and was inspired by the idea of SMS messaging.`,
    },
    {
      id: 4,
      content: `Instagram was launched in 2010 and was acquired by Facebook in 2012 for $1 billion.`,
    },
    {
      id: 5,
      content: `The most liked photo on Instagram is the picture of Lionel Messi celebrating the World Cup  win against Argentina, which has over 75 million likes.`,
    },
    {
      id: 6,
      content: `The first YouTube video was uploaded on April 23, 2005, titled "Me at the zoo" and features co-founder Jawed Karim.`,
    },
    {
      id: 7,
      content: `LinkedIn, launched in 2003, was one of the first social networking sites focused on professional networking.`,
    },
    {
      id: 8,
      content: `Snapchat was initially called Picaboo and was later renamed Snapchat in 2011. `,
    },
    {
      id: 9,
      content: `The hashtag symbol (#) was first used on Twitter in 2007 by user Chris Messina to categorize messages.`,
    },
    {
      id: 10,
      content: `The term "social media" was coined in 2004 by marketing expert Chris Shipley.`,
    },
    {
      id: 11,
      content: `YouTube is the second largest search engine in the world, after Google.`,
    },
    {
      id: 12,
      content: `The average person spends about 2 hours and 24 minutes on social media every day.`,
    },
    {
      id: 13,
      content: `Instagram's "Explore" tab was launched in 2012 and has since become a popular feature for discovering new content.`,
    },
    {
      id: 14,
      content: `LinkedIn was launched in Reid Hoffman's living room in 2002 and has since grown to over 700 million users.`,
    },
    {
      id: 15,
      content: `The first YouTube video to reach 1 billion views was "Gangnam Style" by Psy, which achieved this milestone in 2012.`,
    },
    {
      id: 16,
      content: `Twitter's iconic 140-character limit was originally based on the 160-character limit of SMS messages.`,
    },
  ]
}

export const sampleMostEngagingPosts = [
    {
      "url_id": 44,
      "shortcode": "C9ua8OEPrnJ",
      "logging_page_id": 4208653199,
      "is_verified": "false",
      "profile_pic_url": "https://instagram.fabj8-1.fna.fbcdn.net/v/t51.2885-19/458231760_1597283227500328_1045380096814256938_n.jpg?stp=dst-jpg_s150x150&_nc_ht=instagram.fabj8-1.fna.fbcdn.net&_nc_cat=104&_nc_ohc=zY9owBQmLusQ7kNvgEspLuk&_nc_gid=8777ccb2f35c44d992e6d5a4453e19ef&edm=APfKNqwBAAAA&ccb=7-5&oh=00_AYAam5kxirhWtxkNkfrk8KIk9pDKusX7o5YADZKBojkKjQ&oe=66EEE441&_nc_sid=721f0c",
      "gcp_profile_pic_url": "https://storage.googleapis.com/data.clanconnect.ai/sm/ig/post_analytics_owner/44/4208653199.jpg",
      "username": "themehakbhutani",
      "blocked_by_viewer": "false",
      "restricted_by_viewer": "null",
      "followed_by_viewer": "false",
      "full_name": "Mehak | Content Creator",
      "has_blocked_viewer": "false",
      "is_private": "false",
      "is_unpublished": "false",
      "requested_by_viewer": "false",
      "pass_tiering_recommendation": "true",
      "edge_owner_to_timeline_media": 462,
      "edge_followed_by": 41242,
      "created_at": "2024-09-17 07:12:49",
      "updated_at": "2024-09-17 07:12:49",
      "__typename": "GraphVideo",
      "id": 3417787654702283300,
      "gating_info": "null",
      "fact_check_overall_rating": "null",
      "fact_check_information": "null",
      "sensitivity_friction_info": "null",
      "should_have_sharing_friction": "false",
      "bloks_app_url": "null",
      "media_overlay_info": "null",
      "media_preview": "ABgqqoqjIZc56H0qWTy8lVAXHP4fWqjSksT2p7RsGw+R/P8A/VUuxWpYh2vJx2optugjYN2/HPT+VFQ/IpeZZiVoFO4cDntn/wCvUNw7zorBckk/pWlcToEyTxVOKROBGQR178Dr+FJ6a2KTurDIZk2+WeGGfSir0MIf5sdaKTXmIowqoVt/XOR3H5dM1SuGk2lThF7KvRievvx71eaq04yB+NNPUb2NO1mEiD1xgj36UVhrRTsTc//Z",
      "display_url": "https://instagram.fsal7-1.fna.fbcdn.net/v/t51.29350-15/452379949_1166899281245819_3170017019993058873_n.jpg?stp=dst-jpg_e35_p1080x1080_sh0.08&_nc_ht=instagram.fsal7-1.fna.fbcdn.net&_nc_cat=111&_nc_ohc=4-_7A7NWOIwQ7kNvgH67pgj&edm=APfKNqwBAAAA&ccb=7-5&oh=00_AYB3RNfiurgJAgYhs8eP3nLNkstFXQtxX7Y0S0-TO-71Wg&oe=66A5740B&_nc_sid=721f0c",
      "gcp_display_url": "https://storage.googleapis.com/data.clanconnect.ai/sm/ig/post_analytics_thumbnail/thumbnail/C9ua8OEPrnJ.jpg",
      "accessibility_caption": "",
      "is_dash_eligible": "false",
      "video_dash_manifest": "null",
      "number_of_qualities": 0,
      "has_audio": "true",
      "video_view_count": 8147,
      "video_play_count": 37333,
      "is_video": "true",
      "tracking_token": "eyJ2ZXJzaW9uIjo1LCJwYXlsb2FkIjp7ImlzX2FuYWx5dGljc190cmFja2VkIjp0cnVlLCJ1dWlkIjoiNGMzZjg3Zjk3ZGUzNDNkYmE4ZmIzNTAzMzZmZmZlMTIzNDE3Nzg3NjU0NzAyMjgzMjA5In0sInNpZ25hdHVyZSI6IiJ9",
      "upcoming_event": "null",
      "can_see_insights_as_brand": "false",
      "caption_is_edited": "false",
      "has_ranked_comments": "false",
      "like_and_view_counts_disabled": "false",
      "edge_media_to_parent_comment_count": 68,
      "edge_media_preview_comment_count": 68,
      "comments_disabled": "false",
      "commenting_disabled_for_viewer": "false",
      "taken_at_timestamp": "1975-06-16 15:40:52",
      "edge_media_preview_like_count": 732,
      "is_affiliate": "false",
      "is_paid_partnership": "false",
      "location": "null",
      "nft_asset_info": "null",
      "viewer_has_liked": "false",
      "viewer_has_saved": "false",
      "viewer_has_saved_to_collection": "false",
      "viewer_in_photo_of_you": "false",
      "viewer_can_reshare": "true",
      "is_ad": "false",
      "encoding_status": "null",
      "is_published": "true",
      "product_type": "clips",
      "channel_title": "City Ka Theka",
      "title": "Rs 1000 Mein Premium Whisky | No Rating Review | City ka Theka",
      "thumbnails":
        "https://i.ytimg.com/vi/C7tTdW3DWwU/default.jpg",
      "video_duration": 37.3,
      "thumbnail_src": "https://instagram.fsal7-1.fna.fbcdn.net/v/t51.29350-15/452379949_1166899281245819_3170017019993058873_n.jpg?stp=c0.502.1290.1290a_dst-jpg_e35_s640x640_sh0.08&_nc_ht=instagram.fsal7-1.fna.fbcdn.net&_nc_cat=111&_nc_ohc=4-_7A7NWOIwQ7kNvgH67pgj&edm=APfKNqwBAAAA&ccb=7-5&oh=00_AYDZCZESzowAfHeHxkEpqUhlyoRvVl_2RLLx2pYRGga8MA&oe=66A5740B&_nc_sid=721f0c",
      "comments": 68,
      "likes": 732,
      "video_views": 8147,
      "video_plays": 37333,
      "media_count": 462,
      "followers_count": 41242,
      "er_without_plays": 1.94,
      "er_with_plays": 92.46,
      "er": 1.94,
      "reach": null,
      "impressions": null
    },
    {
      "url_id": 155,
      "shortcode": "C_hspynvlnd",
      "logging_page_id": 318311711,
      "is_verified": "false",
      "profile_pic_url": "https://instagram.fjrs10-1.fna.fbcdn.net/v/t51.2885-19/410033069_375342661817407_8582164164302209140_n.jpg?stp=dst-jpg_s150x150&_nc_ht=instagram.fjrs10-1.fna.fbcdn.net&_nc_cat=107&_nc_ohc=O686KUTHI2oQ7kNvgH01OTp&_nc_gid=962d1295cd94494cb76ece4c2b6f3f8f&edm=APfKNqwBAAAA&ccb=7-5&oh=00_AYAKvM35vTBN0cmm4olFoHwNTa3vKReZW2bpDR8tQ_8ovw&oe=66EEF78C&_nc_sid=721f0c",
      "gcp_profile_pic_url": "https://storage.googleapis.com/data.clanconnect.ai/sm/ig/post_analytics_owner/155/318311711.jpg",
      "username": "anjurisinha",
      "blocked_by_viewer": "false",
      "restricted_by_viewer": "null",
      "followed_by_viewer": "false",
      "full_name": "Anjuri Sinha | Fitness | Fashion | Lifestyle",
      "has_blocked_viewer": "false",
      "is_private": "false",
      "is_unpublished": "false",
      "requested_by_viewer": "false",
      "pass_tiering_recommendation": "true",
      "edge_owner_to_timeline_media": 882,
      "edge_followed_by": 125542,
      "created_at": "2024-09-17 07:14:32",
      "updated_at": "2024-09-17 07:14:32",
      "__typename": "GraphVideo",
      "id": 3450235175441423000,
      "gating_info": "null",
      "fact_check_overall_rating": "null",
      "fact_check_information": "null",
      "sensitivity_friction_info": "null",
      "should_have_sharing_friction": "false",
      "bloks_app_url": "null",
      "media_overlay_info": "null",
      "media_preview": "ABgquBKcpUHaSM+maguDgA+mf6VVaIOgyAGOCH7njPX+lZ3sXa49pnBOPXAoqIdBnuaKYFyRWkjOOhqtlkT5wNy+35VpQtuUj8KY0ascNTsK5mKh8sN17n8e9FWsiP5B09KKyvbSxdrkq5iJHqaeZM4on+6v0qu3WtzIkkcE5HWipSB5OfaiszQ//9k=",
      "display_url": "https://instagram.fjrs10-1.fna.fbcdn.net/v/t51.29350-15/459339814_389161107554692_6595479967684368732_n.jpg?stp=dst-jpg_e35_p1080x1080_sh0.08&_nc_ht=instagram.fjrs10-1.fna.fbcdn.net&_nc_cat=104&_nc_ohc=z2t_tVu7ZxEQ7kNvgENUtnj&_nc_gid=962d1295cd94494cb76ece4c2b6f3f8f&edm=APfKNqwBAAAA&ccb=7-5&oh=00_AYDMpzcNZsAmLfu3E4B9DwS-A4X3YpYW9IdzKXXL_uksow&oe=66EF042E&_nc_sid=721f0c",
      "gcp_display_url": "https://storage.googleapis.com/data.clanconnect.ai/sm/ig/post_analytics_thumbnail/thumbnail/C_hspynvlnd.jpg",
      "accessibility_caption": "",
      "is_dash_eligible": "false",
      "video_dash_manifest": "null",
      "number_of_qualities": 0,
      "has_audio": "true",
      "video_view_count": 6501,
      "video_play_count": 29816,
      "is_video": "true",
      "tracking_token": "eyJ2ZXJzaW9uIjo1LCJwYXlsb2FkIjp7ImlzX2FuYWx5dGljc190cmFja2VkIjp0cnVlLCJ1dWlkIjoiOTYyZDEyOTVjZDk0NDk0Y2I3NmVjZTRjMmI2ZjNmOGYzNDUwMjM1MTc1NDQxNDIyODEzIn0sInNpZ25hdHVyZSI6IiJ9",
      "upcoming_event": "null",
      "can_see_insights_as_brand": "false",
      "caption_is_edited": "false",
      "has_ranked_comments": "false",
      "like_and_view_counts_disabled": "true",
      "edge_media_to_parent_comment_count": 91,
      "edge_media_preview_comment_count": 91,
      "comments_disabled": "false",
      "commenting_disabled_for_viewer": "false",
      "taken_at_timestamp": "1975-06-21 03:06:58",
      "edge_media_preview_like_count": -1,
      "is_affiliate": "false",
      "is_paid_partnership": "false",
      "location": "[object Object]",
      "nft_asset_info": "null",
      "viewer_has_liked": "false",
      "viewer_has_saved": "false",
      "viewer_has_saved_to_collection": "false",
      "viewer_in_photo_of_you": "false",
      "viewer_can_reshare": "true",
      "is_ad": "false",
      "encoding_status": "null",
      "is_published": "true",
      "product_type": "clips",
      "channel_title"
        :
        "The Whiskeypedia",
      "thumbnails"
        :
        "https://i.ytimg.com/vi/obsr6N1JkFk/default.jpg",
      "title"
        :
        "All New Woodnote Premium Whisky Review | Best Whisky Under Rs.1000 | The Whiskeypedia",
      "video_duration": 56.866,
      "thumbnail_src": "https://instagram.fjrs10-1.fna.fbcdn.net/v/t51.29350-15/459339814_389161107554692_6595479967684368732_n.jpg?stp=c0.483.1242.1242a_dst-jpg_e35_s640x640_sh0.08&_nc_ht=instagram.fjrs10-1.fna.fbcdn.net&_nc_cat=104&_nc_ohc=z2t_tVu7ZxEQ7kNvgENUtnj&_nc_gid=962d1295cd94494cb76ece4c2b6f3f8f&edm=APfKNqwBAAAA&ccb=7-5&oh=00_AYDRZyJu31sDvAicrYgz2QgUF8AueeQ688NlJ4hBZGIZGQ&oe=66EF042E&_nc_sid=721f0c",
      "comments": 91,
      "likes": 0,
      "video_views": 6501,
      "video_plays": 29816,
      "media_count": 882,
      "followers_count": 125542,
      "er_without_plays": 0.07,
      "er_with_plays": 23.82,
      "er": 0.07,
      "reach": 0,
      "impressions": 0
    },
    {
      "url_id": 45,
      "shortcode": "C9pBxnyJdG9",
      "logging_page_id": 373823588,
      "is_verified": "false",
      "profile_pic_url": "https://instagram.fmnl8-1.fna.fbcdn.net/v/t51.2885-19/340839502_1288624078700370_3822180529097738740_n.jpg?stp=dst-jpg_s150x150&_nc_ht=instagram.fmnl8-1.fna.fbcdn.net&_nc_cat=106&_nc_ohc=H7gVlBocdrgQ7kNvgEgb8JM&edm=APfKNqwBAAAA&ccb=7-5&oh=00_AYBdQO-Sv_Gj_Jqk9YygC0KtWhPQAUaR_wccluHar31XjQ&oe=66EEFBE9&_nc_sid=721f0c",
      "gcp_profile_pic_url": "https://storage.googleapis.com/data.clanconnect.ai/sm/ig/post_analytics_owner/45/373823588.jpg",
      "username": "pepe_mingg",
      "blocked_by_viewer": "false",
      "restricted_by_viewer": "null",
      "followed_by_viewer": "false",
      "full_name": "Pepe Ming",
      "has_blocked_viewer": "false",
      "is_private": "false",
      "is_unpublished": "false",
      "requested_by_viewer": "false",
      "pass_tiering_recommendation": "true",
      "edge_owner_to_timeline_media": 956,
      "edge_followed_by": 66747,
      "created_at": "2024-09-17 07:12:56",
      "updated_at": "2024-09-17 07:12:56",
      "__typename": "GraphVideo",
      "id": 3416269600355373600,
      "gating_info": "null",
      "fact_check_overall_rating": "null",
      "fact_check_information": "null",
      "sensitivity_friction_info": "null",
      "should_have_sharing_friction": "false",
      "bloks_app_url": "null",
      "media_overlay_info": "null",
      "media_preview": "ABgqoBOPrTvLNW7ePOCfw/xq8rxglEIHcsen51Fzcw/KOcHj68UVr4jHCsNxOSTzmikMSN1QFjkqOBVBsEkjoecVaknUKVX6f57Zp62qyDeDj0A6UDTXXUhhi8zkdR+Q/wDr+gFFS+cqcEYP+z2/OiiwOVxsBRlxwwHrUkTBRtX14/lWRGcdPQ/zq9a/6sfU0zO9y27NjoMe+OaKhkPy/hRTQH//2Q==",
      "display_url": "https://instagram.fvno2-1.fna.fbcdn.net/v/t51.29350-15/452170314_490176460267195_8618122032805698756_n.jpg?stp=dst-jpg_e15&_nc_ht=instagram.fvno2-1.fna.fbcdn.net&_nc_cat=107&_nc_ohc=lmNI6BtOImoQ7kNvgFdBgqn&edm=APfKNqwBAAAA&ccb=7-5&oh=00_AYA6-xg7cx-hluFr1PJf_E-Til9CCkOJ_9ilh-L9ROtRCQ&oe=66A5719F&_nc_sid=721f0c",
      "gcp_display_url": "https://storage.googleapis.com/data.clanconnect.ai/sm/ig/post_analytics_thumbnail/thumbnail/C9pBxnyJdG9.jpg",
      "accessibility_caption": "",
      "is_dash_eligible": "false",
      "video_dash_manifest": "null",
      "number_of_qualities": 0,
      "has_audio": "true",
      "video_view_count": 10804,
      "video_play_count": 48722,
      "is_video": "true",
      "tracking_token": "eyJ2ZXJzaW9uIjo1LCJwYXlsb2FkIjp7ImlzX2FuYWx5dGljc190cmFja2VkIjp0cnVlLCJ1dWlkIjoiOGMzYzUwOTAyMGE5NGVhNjliOTc0NjQ2YTYxM2IzNjAzNDE2MjY5NjAwMzU1MzczNTAxIn0sInNpZ25hdHVyZSI6IiJ9",
      "upcoming_event": "null",
      "can_see_insights_as_brand": "false",
      "caption_is_edited": "false",
      "has_ranked_comments": "false",
      "like_and_view_counts_disabled": "false",
      "edge_media_to_parent_comment_count": 71,
      "edge_media_preview_comment_count": 71,
      "comments_disabled": "false",
      "commenting_disabled_for_viewer": "false",
      "taken_at_timestamp": "1975-06-16 10:38:44",
      "edge_media_preview_like_count": 2097,
      "is_affiliate": "false",
      "is_paid_partnership": "false",
      "location": "null",
      "nft_asset_info": "null",
      "viewer_has_liked": "false",
      "viewer_has_saved": "false",
      "viewer_has_saved_to_collection": "false",
      "viewer_in_photo_of_you": "false",
      "viewer_can_reshare": "true",
      "is_ad": "false",
      "encoding_status": "null",
      "is_published": "true",
      "product_type": "clips",
      "video_duration": 43.14,
      "thumbnail_src": "https://instagram.fvno2-1.fna.fbcdn.net/v/t51.29350-15/452170314_490176460267195_8618122032805698756_n.jpg?stp=c0.280.720.720a_dst-jpg_e15_s640x640&_nc_ht=instagram.fvno2-1.fna.fbcdn.net&_nc_cat=107&_nc_ohc=lmNI6BtOImoQ7kNvgFdBgqn&edm=APfKNqwBAAAA&ccb=7-5&oh=00_AYDybJHx05yOoUl4NH3ZSU3z-t2tiRzL_4qXggw1LwRM4A&oe=66A5719F&_nc_sid=721f0c",
      "comments": 71,
      "likes": 2097,
      "video_views": 10804,
      "video_plays": 48722,
      "media_count": 956,
      "followers_count": 66747,
      "er_without_plays": 3.25,
      "er_with_plays": 76.24,
      "er": 3.25,
      "reach": null,
      "impressions": null,
      "channel_title"
        :
        "Woodnote Whisky Review | #whiskeywednesday",
      "thumbnails"
        :
        "https://i.ytimg.com/vi/vdbLseIxhcY/default.jpg",
      "title"
        :
        "Woodnote Whisky Review | #whiskeywednesday"
    },
    {
      "url_id": 114,
      "shortcode": "C-5ZS9Jys57",
      "logging_page_id": 3550041365,
      "is_verified": "false",
      "profile_pic_url": "https://instagram.fpnh11-2.fna.fbcdn.net/v/t51.2885-19/457253822_819094456974906_4009807405122611632_n.jpg?stp=dst-jpg_s150x150&_nc_ht=instagram.fpnh11-2.fna.fbcdn.net&_nc_cat=106&_nc_ohc=x7RiyT9yT-UQ7kNvgFJswiP&_nc_gid=258f9c82da4b44fa83bbbd1bdcacd52a&edm=APfKNqwBAAAA&ccb=7-5&oh=00_AYDcshNGN7S-yN68imCdj6gsjUYMc55j6JsCOdUKevKTOw&oe=66EF061B&_nc_sid=721f0c",
      "gcp_profile_pic_url": "https://storage.googleapis.com/data.clanconnect.ai/sm/ig/post_analytics_owner/114/3550041365.jpg",
      "username": "akhila_boddula",
      "blocked_by_viewer": "false",
      "restricted_by_viewer": "null",
      "followed_by_viewer": "false",
      "full_name": "My Fairy Tale ??‍♀️",
      "has_blocked_viewer": "false",
      "is_private": "false",
      "is_unpublished": "false",
      "requested_by_viewer": "false",
      "pass_tiering_recommendation": "true",
      "edge_owner_to_timeline_media": 591,
      "edge_followed_by": 28897,
      "created_at": "2024-09-17 07:13:43",
      "updated_at": "2024-09-17 07:13:43",
      "__typename": "GraphVideo",
      "id": 3438891044249980400,
      "gating_info": "null",
      "fact_check_overall_rating": "null",
      "fact_check_information": "null",
      "sensitivity_friction_info": "null",
      "should_have_sharing_friction": "false",
      "bloks_app_url": "null",
      "media_overlay_info": "null",
      "media_preview": "",
      "display_url": "https://instagram.fbkk23-1.fna.fbcdn.net/v/t51.29350-15/456328478_2129161257465741_5196243932513833131_n.jpg?stp=dst-jpg_e35_p1080x1080_sh0.08&_nc_ht=instagram.fbkk23-1.fna.fbcdn.net&_nc_cat=109&_nc_ohc=RFVgBy_t2n0Q7kNvgE-jHwT&edm=APfKNqwBAAAA&ccb=7-5&oh=00_AYDReGfi05wq6KUEyramPkhbP-GGC37hAnYVuASqrBkbCg&oe=66D20B1D&_nc_sid=721f0c",
      "gcp_display_url": "https://storage.googleapis.com/data.clanconnect.ai/sm/ig/post_analytics_thumbnail/thumbnail/C-5ZS9Jys57.jpg",
      "accessibility_caption": "",
      "is_dash_eligible": "false",
      "video_dash_manifest": "null",
      "number_of_qualities": 0,
      "has_audio": "true",
      "video_view_count": 11493,
      "video_play_count": 59181,
      "is_video": "true",
      "tracking_token": "eyJ2ZXJzaW9uIjo1LCJwYXlsb2FkIjp7ImlzX2FuYWx5dGljc190cmFja2VkIjp0cnVlLCJ1dWlkIjoiYzljZDI4NGVlYmRkNDQ3NTg5MTk1ZWI0MGRlZDM0YmYzNDM4ODkxMDQ0MjQ5OTgwNTM5In0sInNpZ25hdHVyZSI6IiJ9",
      "upcoming_event": "null",
      "can_see_insights_as_brand": "false",
      "caption_is_edited": "false",
      "has_ranked_comments": "false",
      "like_and_view_counts_disabled": "false",
      "edge_media_to_parent_comment_count": 5,
      "edge_media_preview_comment_count": 5,
      "comments_disabled": "false",
      "commenting_disabled_for_viewer": "false",
      "taken_at_timestamp": "1975-06-19 13:33:17",
      "edge_media_preview_like_count": 939,
      "is_affiliate": "false",
      "is_paid_partnership": "false",
      "location": "null",
      "nft_asset_info": "null",
      "viewer_has_liked": "false",
      "viewer_has_saved": "false",
      "viewer_has_saved_to_collection": "false",
      "viewer_in_photo_of_you": "false",
      "viewer_can_reshare": "true",
      "is_ad": "false",
      "encoding_status": "null",
      "is_published": "true",
      "product_type": "clips",
      "video_duration": 25.2,
      "thumbnail_src": "https://instagram.fbkk23-1.fna.fbcdn.net/v/t51.29350-15/456328478_2129161257465741_5196243932513833131_n.jpg?stp=c0.1312.3376.3376a_dst-jpg_e35_s640x640_sh0.08&_nc_ht=instagram.fbkk23-1.fna.fbcdn.net&_nc_cat=109&_nc_ohc=RFVgBy_t2n0Q7kNvgE-jHwT&edm=APfKNqwBAAAA&ccb=7-5&oh=00_AYAzuD1eeQoBFp3mQM3VzQ1JXFmdgedckG09J4hqsZkvSQ&oe=66D20B1D&_nc_sid=721f0c",
      "comments": 5,
      "likes": 939,
      "video_views": 11493,
      "video_plays": 59181,
      "media_count": 591,
      "followers_count": 28897,
      "er_without_plays": 3.27,
      "er_with_plays": 208.07,
      "er": 3.27,
      "reach": null,
      "impressions": null,
      "channel_title"
        :
        "The Whiskeypedia",
      "thumbnails"
        :
        "https://i.ytimg.com/vi/obsr6N1JkFk/default.jpg",
      "title"
        :
        "All New Woodnote Premium Whisky Review | Best Whisky Under Rs.1000 | The Whiskeypedia",
    },
    {
      "url_id": 125,
      "shortcode": "C_LF61nvpLS",
      "logging_page_id": 2269387552,
      "is_verified": "true",
      "profile_pic_url": "https://scontent-ord5-1.cdninstagram.com/v/t51.2885-19/436220736_444093087987389_3426416156586044715_n.jpg?stp=dst-jpg_s150x150&_nc_ht=scontent-ord5-1.cdninstagram.com&_nc_cat=105&_nc_ohc=-T2lJJpfXWQQ7kNvgEHFmP0&_nc_gid=4eeda26e4074414e8ee54e0a2552d025&edm=APfKNqwBAAAA&ccb=7-5&oh=00_AYB3vpnP3nVazqmkLzohRALEZFte4qba6yTbisKoyS5fmA&oe=66EEFDDC&_nc_sid=721f0c",
      "gcp_profile_pic_url": "https://storage.googleapis.com/data.clanconnect.ai/sm/ig/post_analytics_owner/125/2269387552.jpg",
      "username": "komalchawlaofficial",
      "blocked_by_viewer": "false",
      "restricted_by_viewer": "null",
      "followed_by_viewer": "false",
      "full_name": "Komal Chawla | Travel & Lifestyle Blogger |",
      "has_blocked_viewer": "false",
      "is_private": "false",
      "is_unpublished": "false",
      "requested_by_viewer": "false",
      "pass_tiering_recommendation": "true",
      "edge_owner_to_timeline_media": 1964,
      "edge_followed_by": 104803,
      "created_at": "2024-09-17 07:14:25",
      "updated_at": "2024-09-17 07:14:25",
      "__typename": "GraphVideo",
      "id": 3443872373592199700,
      "gating_info": "null",
      "fact_check_overall_rating": "null",
      "fact_check_information": "null",
      "sensitivity_friction_info": "null",
      "should_have_sharing_friction": "false",
      "bloks_app_url": "null",
      "media_overlay_info": "null",
      "media_preview": "ABgqP7XYA5Oc9P8APv6VD/arls5/D2qCe0U/Mp2kAce1JHGoiII+YsB09Rxz29ayVnrr+JCXNszTg1I7huOVxzn/ADmiss2LAE5yRnp3GOP1oqk+zFe3UtQHccv909QR265+lRRT7pkQcIDt+o6ZPuetNa3kx378e3vVVASRjvShHcqL5TQWTacfeHY/Q45/DnNFRCNwTwScY5P5/hRWVmRY3JSAjH0U/wAjXO26ncp9GUfmf/rV05GeD3rLsVG5+OhGPb71dK0NTU2CiloqRn//2Q==",
      "display_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/457288694_520388540568410_2095913732352090615_n.jpg?stp=dst-jpg_e15&_nc_ht=scontent-cph2-1.cdninstagram.com&_nc_cat=102&_nc_ohc=aRKZYPfTG_0Q7kNvgHKy4aK&edm=APfKNqwBAAAA&ccb=7-5&oh=00_AYDCukcRoypg4lDWPr8Y79YaJUNpUTAGBjahMMLn7e01uw&oe=66D4B115&_nc_sid=721f0c",
      "gcp_display_url": "https://storage.googleapis.com/data.clanconnect.ai/sm/ig/post_analytics_thumbnail/thumbnail/C_LF61nvpLS.jpg",
      "accessibility_caption": "",
      "is_dash_eligible": "false",
      "video_dash_manifest": "null",
      "number_of_qualities": 0,
      "has_audio": "true",
      "video_view_count": 39583,
      "video_play_count": 87768,
      "is_video": "true",
      "tracking_token": "eyJ2ZXJzaW9uIjo1LCJwYXlsb2FkIjp7ImlzX2FuYWx5dGljc190cmFja2VkIjp0cnVlLCJ1dWlkIjoiZTRhOWM4YmMwOGViNGVmNGJkYzQwNGE0ZGU4MDI0ZmYzNDQzODcyMzczNTkyMTk5ODkwIn0sInNpZ25hdHVyZSI6IiJ9",
      "upcoming_event": "null",
      "can_see_insights_as_brand": "false",
      "caption_is_edited": "false",
      "has_ranked_comments": "false",
      "like_and_view_counts_disabled": "false",
      "edge_media_to_parent_comment_count": 23,
      "edge_media_preview_comment_count": 23,
      "comments_disabled": "false",
      "commenting_disabled_for_viewer": "false",
      "taken_at_timestamp": "1975-06-20 06:03:18",
      "edge_media_preview_like_count": 1491,
      "is_affiliate": "false",
      "is_paid_partnership": "false",
      "location": "null",
      "nft_asset_info": "null",
      "viewer_has_liked": "false",
      "viewer_has_saved": "false",
      "viewer_has_saved_to_collection": "false",
      "viewer_in_photo_of_you": "false",
      "viewer_can_reshare": "true",
      "is_ad": "false",
      "encoding_status": "null",
      "is_published": "true",
      "product_type": "clips",
      "video_duration": 45.487,
      "thumbnail_src": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/457288694_520388540568410_2095913732352090615_n.jpg?stp=c0.350.900.900a_dst-jpg_e15_s640x640&_nc_ht=scontent-cph2-1.cdninstagram.com&_nc_cat=102&_nc_ohc=aRKZYPfTG_0Q7kNvgHKy4aK&edm=APfKNqwBAAAA&ccb=7-5&oh=00_AYCrIEU_oMfLfUZUqJ60IPnbeeHAIoTnu1BomX7BpxdG4A&oe=66D4B115&_nc_sid=721f0c",
      "comments": 23,
      "likes": 1491,
      "video_views": 39583,
      "video_plays": 87768,
      "media_count": 1964,
      "followers_count": 104803,
      "er_without_plays": 1.44,
      "er_with_plays": 85.19,
      "er": 1.44,
      "reach": 0,
      "impressions": 0,
      "channel_title": "City Ka Theka",
      "title": "Rs 1000 Mein Premium Whisky | No Rating Review | City ka Theka",
      "thumbnails":
        "https://i.ytimg.com/vi/C7tTdW3DWwU/default.jpg",
    }
  ]
export  const sampleMostEngagingInfluencers = [
    {
      total_likes: 9909,
      total_er: 2.6,
      video_plays: 156221,
      total_comments: 187,
      total_post: 1,
      full_name: "Shivali",
      username: "classifiedbird",
      gcp_profile_pic_url: "https://storage.googleapis.com/data.clanconnect.ai/sm/ig/post_analytics_owner/115/1433674909.jpg",
      profile_image_url: "https://yt3.ggpht.com/ytc/AIdro_kT5Zh9Lt3jfWzvyOH9-MdHONtZsWSjQN_Yc_ilkFmQau8=s88-c-k-c0x00ffffff-no-rj",
      custom_url: "@whiskeypedia",
      "channel_title": "City Ka Theka",
      "title": "Rs 1000 Mein Premium Whisky | No Rating Review | City ka Theka",
      "thumbnails":
        "https://i.ytimg.com/vi/C7tTdW3DWwU/default.jpg",
    },
    {
      total_likes: 2097,
      total_er: 3.25,
      video_plays: 48722,
      total_comments: 71,
      total_post: 1,
      full_name: "Pepe Ming",
      username: "pepe_mingg",
      gcp_profile_pic_url: "https://storage.googleapis.com/data.clanconnect.ai/sm/ig/post_analytics_owner/45/373823588.jpg",
      profile_image_url: "https://yt3.ggpht.com/iWBk85wX4Bc4cttBiOJsemSc1kl6eZ6IoxsiCQy1LdZ84bb1Wo3ztLtqK0P0zHFj2hKKZ8yq1W8=s88-c-k-c0x00ffffff-no-rj",
      custom_url: "@citykatheka",
      "channel_title": "City Ka Theka",
      "title": "Rs 1000 Mein Premium Whisky | No Rating Review | City ka Theka",
      "thumbnails":
        "https://i.ytimg.com/vi/C7tTdW3DWwU/default.jpg",
    },
    {
      total_likes: 1768,
      total_er: 4.3,
      video_plays: 55954,
      total_comments: 18,
      total_post: 1,
      full_name: "Shashwat Sharma",
      username: "shashwat_sharmaa",
      gcp_profile_pic_url: "https://storage.googleapis.com/data.clanconnect.ai/sm/ig/post_analytics_owner/113/32926392284.jpg",
      profile_image_url: "https://yt3.ggpht.com/ytc/AIdro_lLPmaxkx9q6gRTSTD0OGCjjjO-vTc76kb2Qm5ggHWYMg=s88-c-k-c0x00ffffff-no-rj",
      custom_url: "@mbsmancave",
      "channel_title": "City Ka Theka",
      "title": "Rs 1000 Mein Premium Whisky | No Rating Review | City ka Theka",
      "thumbnails":
        "https://i.ytimg.com/vi/C7tTdW3DWwU/default.jpg",
    },
    {
      total_likes: 939,
      total_er: 3.27,
      video_plays: 59181,
      total_comments: 5,
      total_post: 1,
      full_name: "My Fairy Tale ??‍♀️",
      username: "akhila_boddula",
      gcp_profile_pic_url: "https://storage.googleapis.com/data.clanconnect.ai/sm/ig/post_analytics_owner/114/3550041365.jpg",
      profile_image_url: "https://yt3.ggpht.com/ytc/AIdro_kT5Zh9Lt3jfWzvyOH9-MdHONtZsWSjQN_Yc_ilkFmQau8=s88-c-k-c0x00ffffff-no-rj",
      custom_url: "@whiskeypedia",
      "channel_title": "City Ka Theka",
      "title": "Rs 1000 Mein Premium Whisky | No Rating Review | City ka Theka",
      "thumbnails":
        "https://i.ytimg.com/vi/C7tTdW3DWwU/default.jpg",
    },
    {
      total_likes: 732,
      total_er: 1.94,
      video_plays: 37333,
      total_comments: 68,
      total_post: 1,
      full_name: "Mehak | Content Creator",
      username: "themehakbhutani",
      gcp_profile_pic_url: "https://storage.googleapis.com/data.clanconnect.ai/sm/ig/post_analytics_owner/44/4208653199.jpg",
      profile_image_url: "https://yt3.ggpht.com/ytc/AIdro_lLPmaxkx9q6gRTSTD0OGCjjjO-vTc76kb2Qm5ggHWYMg=s88-c-k-c0x00ffffff-no-rj",
      custom_url: "@mbsmancave"
    },
  ];

export const samplePostDetailedData = [
  {
    url_id: 1,
    shortcode: "abc123",
    video_id: "xyz456",
    gcp_display_url: "https://storage.googleapis.com/data.clanconnect.ai/sm/ig/post_analytics_thumbnail/thumbnail/C9ua8OEPrnJ.jpg",
    full_name: "Mehak | Content Creator",
    username: "themehakbhutani",
    er: "1.94",
    video_duration: 37,
    video_plays: 100,
    view_count: 37300,
    like_count: 732,
    comment_count: 68,
    created_at: "2024-09-17T00:00:00Z",
    channel_title: "City Ka Theka",
    thumbnails
      :
      "https://i.ytimg.com/vi/C7tTdW3DWwU/default.jpg",
    title
      :
      "Rs 1000 Mein Premium Whisky | No Rating Review | City ka Theka"
  },
  {
    url_id: 2,
    shortcode: "def456",
    video_id: "uvw789",
    video_plays: 300,

    channel_title
      :
      "MBs Mancave",
    thumbnails
      :
      "https://i.ytimg.com/vi/vdbLseIxhcY/default.jpg",
    title
      :
      "Woodnote Whisky Review | #whiskeywednesday",
    gcp_display_url: "https://storage.googleapis.com/data.clanconnect.ai/sm/ig/post_analytics_thumbnail/thumbnail/C_hspynvlnd.jpg",
    full_name: "Anjuri Sinha | Fitness | Fashion | Lifestyle",
    username: "anjurisinha",
    er: "0.07",
    video_duration: 57,
    view_count: 29800,
    like_count: 0,
    comment_count: 91,
    created_at: "2024-09-17T00:00:00Z",
  },
  {
    url_id: 3,
    shortcode: "ghi789",
    video_id: "rst012",
    video_plays: 1500,
    gcp_display_url: "https://storage.googleapis.com/data.clanconnect.ai/sm/ig/post_analytics_thumbnail/thumbnail/C9pBxnyJdG9.jpg",
    full_name: "Pepe Ming",
    username: "pepeming",
    er: "3.25",
    video_duration: 43,
    view_count: 48700,
    like_count: 2100,
    comment_count: 71,
    created_at: "2024-09-17T00:00:00Z",
    channel_title
      :
      "The Whiskeypedia",
    thumbnails
      :
      "https://i.ytimg.com/vi/obsr6N1JkFk/default.jpg",
    title
      :
      "All New Woodnote Premium Whisky Review | Best Whisky Under Rs.1000 | The Whiskeypedia"
  },
  {
    url_id: 4,
    shortcode: "jkl012",
    video_id: "mno345",
    video_plays: 2000,
    gcp_display_url: "https://storage.googleapis.com/data.clanconnect.ai/sm/ig/post_analytics_thumbnail/thumbnail/C-5ZS9Jys57.jpg",
    full_name: "My Fairy Tale ??‍♀️",
    username: "myfairytale",
    er: "3.27",
    video_duration: 25,
    view_count: 59200,
    like_count: 939,
    comment_count: 5,
    created_at: "2024-09-17T00:00:00Z",
    channel_title: "City Ka Theka",
    thumbnails
      :
      "https://i.ytimg.com/vi/C7tTdW3DWwU/default.jpg",
    title
      :
      "Rs 1000 Mein Premium Whisky | No Rating Review | City ka Theka"

  },
  {
    url_id: 5,
    shortcode: "mno345",
    video_id: "pqr678",
    video_plays: 2100,
    gcp_display_url: "https://storage.googleapis.com/data.clanconnect.ai/sm/ig/post_analytics_thumbnail/thumbnail/C_LF61nvpLS.jpg",
    full_name: "Komal Chawla | Travel & Lifestyle Blogger",
    username: "komalchawla",
    er: "1.44",
    video_duration: 45,
    view_count: 87800,
    like_count: 1500,
    comment_count: 23,
    created_at: "2024-09-17T00:00:00Z",
    channel_title
      :
      "The Whiskeypedia",
    thumbnails
      :
      "https://i.ytimg.com/vi/obsr6N1JkFk/default.jpg",
    title
      :
      "All New Woodnote Premium Whisky Review | Best Whisky Under Rs.1000 | The Whiskeypedia"
  },
];


export const sampleInfluencerDetailedData = [
  {
    full_name: "Shashwat Sharma",
    username: "shashwat_sharma",
    gcp_profile_pic_url: "https://storage.googleapis.com/data.clanconnect.ai/sm/ig/post_analytics_owner/113/32926392284.jpg",
    profile_image_url: "https://yt3.ggpht.com/iWBk85wX4Bc4cttBiOJsemSc1kl6eZ6IoxsiCQy1LdZ84bb1Wo3ztLtqK0P0zHFj2hKKZ8yq1W8=s88-c-k-c0x00ffffff-no-rj",
    total_post: 1,
    total_er: 4.3,
    video_plays: 56000,
    total_views: null,
    total_likes: 1800,
    total_comments: 18,
    custom_url: "@citykatheka",
    "channel_title": "City Ka Theka",
    "title": "Rs 1000 Mein Premium Whisky | No Rating Review | City ka Theka",
    "thumbnails":
      "https://i.ytimg.com/vi/C7tTdW3DWwU/default.jpg",
  },
  {
    full_name: "My Fairy Tale ??‍♀️",
    username: "myfairytale",
    gcp_profile_pic_url: "https://storage.googleapis.com/data.clanconnect.ai/sm/ig/post_analytics_owner/114/3550041365.jpg",
    profile_image_url: "https://i.ytimg.com/vi/obsr6N1JkFk/default.jpg",
    total_post: 1,
    total_er: 3.27,
    video_plays: 59200,
    total_views: null,
    total_likes: 939,
    total_comments: 5,
    custom_url: "@whiskeypedia",
    title: "All New Woodnote Premium Whisky Review | Best Whisky Under Rs.1000 | The Whiskeypedia",
    "channel_title"
      :
      "The Whiskeypedia",
    "thumbnails"
      :
      "https://i.ytimg.com/vi/obsr6N1JkFk/default.jpg",

  },
  {
    full_name: "Pepe Ming",
    username: "pepeming",
    gcp_profile_pic_url: "https://storage.googleapis.com/data.clanconnect.ai/sm/ig/post_analytics_owner/45/373823588.jpg",
    profile_image_url: "https://i.ytimg.com/vi/C7tTdW3DWwU/default.jpg",
    total_post: 1,
    total_er: 3.25,
    video_plays: 48700,
    total_views: null,
    total_likes: 2100,
    total_comments: 71,
    custom_url: "@mbsmancave",
    "channel_title": "City Ka Theka",
    "title": "Rs 1000 Mein Premium Whisky | No Rating Review | City ka Theka",
    "thumbnails":
      "https://i.ytimg.com/vi/C7tTdW3DWwU/default.jpg",
  },
  {
    full_name: "Shivali",
    username: "shivali_official",
    gcp_profile_pic_url: "https://storage.googleapis.com/data.clanconnect.ai/sm/ig/post_analytics_owner/115/1433674909.jpg",
    profile_image_url: "https://i.ytimg.com/vi/obsr6N1JkFk/default.jpg",
    total_post: 1,
    total_er: 2.6,
    video_plays: 156200,
    total_views: null,
    total_likes: 9900,
    total_comments: 187,
    custom_url: "@whiskeypedia",
    title: "All New Woodnote Premium Whisky Review | Best Whisky Under Rs.1000 | The Whiskeypedia",
    "channel_title"
      :
      "The Whiskeypedia",
    "thumbnails"
      :
      "https://i.ytimg.com/vi/obsr6N1JkFk/default.jpg",
  },
  {
    full_name: "Mehak | Content Creator",
    username: "themehakbhutani",
    gcp_profile_pic_url: "https://storage.googleapis.com/data.clanconnect.ai/sm/ig/post_analytics_thumbnail/thumbnail/C9ua8OEPrnJ.jpg",
    profile_image_url: "https://i.ytimg.com/vi/C7tTdW3DWwU/default.jpg",
    custom_url: "@citykatheka",
    total_post: 1,
    total_er: 1.94,
    video_plays: 37300,
    total_views: null,
    total_likes: 732,
    total_comments: 68,
    "channel_title": "City Ka Theka",
    "title": "Rs 1000 Mein Premium Whisky | No Rating Review | City ka Theka",
    "thumbnails":
      "https://i.ytimg.com/vi/C7tTdW3DWwU/default.jpg",
  },
];
